export interface ChatbotDataModel {
    status: boolean;
    data: {
        chat_id: string;
        message: string;
        chat_state: string;
    }
}

export class ChatbotData {
    static create (model: ChatbotDataModel): ChatbotData {
        const {
            data: {
                chat_id: id,
                message: message,
                chat_state: state
            }
        } = model;

        return new ChatbotData(id, message, state);
    }
    constructor (
        public readonly id: string,
        public readonly message: string,
        public readonly state: string
    ){}
}